import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

const DEFAULT_SORT = 'created_desc'
const VALID_SORTS = ['created_desc', 'price_asc', 'price_desc', 'name_asc']

function parsePage(val) {
  const n = Number(val)
  return Number.isFinite(n) && n >= 1 ? Math.floor(n) : 1
}

export default function useShopFilters() {
  const [searchParams, setSearchParams] = useSearchParams()

  const filters = useMemo(() => {
    const search = searchParams.get('search') ?? ''
    const categorySlug = searchParams.get('categorySlug') ?? ''
    const minPriceRaw = searchParams.get('minPrice')
    const maxPriceRaw = searchParams.get('maxPrice')
    const minPrice = minPriceRaw != null && minPriceRaw !== '' ? Number(minPriceRaw) : undefined
    const maxPrice = maxPriceRaw != null && maxPriceRaw !== '' ? Number(maxPriceRaw) : undefined
    const sortRaw = searchParams.get('sort')
    const sort = VALID_SORTS.includes(sortRaw) ? sortRaw : DEFAULT_SORT
    const page = parsePage(searchParams.get('page'))

    return {
      search: typeof search === 'string' ? search : '',
      categorySlug: typeof categorySlug === 'string' ? categorySlug : '',
      minPrice: Number.isFinite(minPrice) ? minPrice : undefined,
      maxPrice: Number.isFinite(maxPrice) ? maxPrice : undefined,
      sort,
      page,
    }
  }, [searchParams])

  const setFilter = (key, value) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev)
      const resetPage = key !== 'page'

      if (value === undefined || value === null || value === '') {
        next.delete(key)
      } else {
        next.set(key, String(value))
      }

      if (resetPage) {
        next.set('page', '1')
      }
      return next
    })
  }

  const resetFilters = () => {
    setSearchParams({})
  }

  return { filters, setFilter, resetFilters }
}
